var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#38393C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3747 6.23176L8 8.6065L5.62527 6.23176C5.32211 5.92861 4.83369 5.92861 4.53053 6.23176C4.22737 6.53492 4.22737 7.02334 4.53053 7.3265L7.46106 10.257C7.61264 10.4086 7.81474 10.476 8 10.476C8.20211 10.476 8.38737 10.4086 8.53895 10.257L11.4695 7.3265C11.7726 7.02334 11.7726 6.53492 11.4695 6.23176C11.1663 5.92861 10.6779 5.92861 10.3747 6.23176Z",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1432 0H3.85684C1.73474 0 0 1.73474 0 3.85684V12.1432C0 14.2653 1.73474 16 3.85684 16H12.1432C14.2653 16 16 14.2653 16 12.1432V3.85684C16 1.73474 14.2653 0 12.1432 0ZM14.4505 12.1432C14.4505 13.4232 13.4063 14.4505 12.1432 14.4505H3.85684C2.57684 14.4505 1.54947 13.4063 1.54947 12.1432V3.85684C1.54947 2.57684 2.59368 1.54947 3.85684 1.54947H12.1432C13.4232 1.54947 14.4505 2.59368 14.4505 3.85684V12.1432Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.1f2b7dda3e4a428a1f70a9f761bdbbe6.svg";
export { ForwardRef as ReactComponent };